import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import useSnackBar from "../../../../components/Commons/SnackBar/useSnackBar";
import { useCompanyStore } from "../../../../store/AuthStore";
import { useEffect, useState } from "react";
import { GridColDef, GridRowsProp } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import { Header } from "../../../../components/Header";
import DataTable from "../../../../components/Tables/GridTableMaterialUI/DataTable";
import { PurchaseInvoice } from "../../../../interfaces/Purchases/Invoices/purchaseInvoices";
import { useGridPreferences } from "../../../../hooks/useGridPreferences";
import { FilterTable } from "../../../../components/Filter";
import { usePurchaseInvoiceColumns } from "../../../Purchases/PurchaseInvoice/Table/columns";
import { usePreferenceTypesStore } from "../../../../store/Preferences/PreferencesStore";
import { PreferenceType } from "../../../../interfaces/Commons/Preferences/preferences";
import DataTableSticky from "../../../../components/Tables/GridTableMaterialUI/DataTableSticky";
import { Spinner } from "../../../../components/Commons/Spinner/Spinner";


export const TableAnalysisPurchaseInvoices = () => {
    const [t] = useTranslation("global");
    const navigate = useNavigate();
    const location = useLocation();
    const { showSnackBar, SnackbarComponent } = useSnackBar();
    const { companyState } = useCompanyStore();
    const [isLoadingDataTable, setIsLoadingDataTable] = useState(false);
    const [unauthorized, setUnauthorized] = useState(true);
    const [purchasesInvoiceData, setPurchasesInvoiceData] = useState<GridRowsProp>([]);
    const [messageSnack, setMessageSnack] = useState("");
    const [myPreferences, setMyPreferences] = useState({});
    const { columnsPurchaseinvoices } = usePurchaseInvoiceColumns();
    const [columns, setColumns] = useState<GridColDef<PurchaseInvoice>[]>(columnsPurchaseinvoices);
    const {
        LoadColumnsOrder,
        LoadColumnsVisible,
        LoadColumnsSort,
        VerifyPreferenceOrderByResourceRoute,
        VerifyPreferenceVisualByResourceRoute,
        VerifyPreferenceSortByResourceRoute } = useGridPreferences();
    const [mySortPreference, setMySortPreference] = useState([]);
    const { preferenceTypes } = usePreferenceTypesStore.getState();
    const [isLoadedMyLocalPreferences, setIsLoadedMyLocalPreferences] = useState(false);
    const initFilter = '/purchaseinvoices?filter='

    const loadTablePreferences = async () => {
        // get preferencetypes in Store
        let hasPreferenceOrder: boolean = false;
        // if exists preferencetypes
        if (preferenceTypes.length) {
            // if exists order preferences
            let myPreferencesColumnsOrder = preferenceTypes.find((item: PreferenceType) => item.preference_type_name === "GridColumnsOrder");
            if (myPreferencesColumnsOrder) {
                try {
                    const preference = await VerifyPreferenceOrderByResourceRoute(
                        "/reportpurchaseinvoices",
                        myPreferencesColumnsOrder.preference_type_id ?? 0
                    );
                    if (preference) {
                        setColumns(await LoadColumnsOrder("/reportpurchaseinvoices", [], preference?.preference_value));
                        hasPreferenceOrder = true;
                    }
                } catch (error) {
                    showSnackBar(`Error fetching column order preferences:${error}`, "error");
                }
            }

            let myPreferencesColumnsVisual = preferenceTypes.find((item: PreferenceType) => item.preference_type_name === "GridColumnsVisibility");
            // if exists visual preferences
            if (myPreferencesColumnsVisual) {
                try {
                    const preference = await VerifyPreferenceVisualByResourceRoute(
                        "/reportpurchaseinvoices",
                        myPreferencesColumnsVisual.preference_type_id ?? 0
                    );
                    if (preference) {
                        let myLocalPreferences = await LoadColumnsVisible("/reportpurchaseinvoices", preference);
                        setMyPreferences(myLocalPreferences);
                    }
                } catch (error) {
                    console.error("Error fetching column visual preferences:", error);
                }
            }

            let myPreferencesColumnsSort = preferenceTypes.find((item: PreferenceType) => item.preference_type_name === "GridColumnsSorting");
            // if exists sort preferences
            if (myPreferencesColumnsSort) {
                try {
                    const preference = await VerifyPreferenceSortByResourceRoute(
                        "/reportpurchaseinvoices",
                        myPreferencesColumnsSort.preference_type_id ?? 0
                    );
                    if (preference) {
                        let myLocalPreferences = await LoadColumnsSort("/reportpurchaseinvoices", preference);
                        setMySortPreference(myLocalPreferences);
                    }
                } catch (error) {
                    console.error("Error fetching column sort preferences:", error);
                }
            }

        }
        if (!hasPreferenceOrder) {
            setColumns(columnsPurchaseinvoices);
        }
        setIsLoadedMyLocalPreferences(true);
    }

    useEffect(() => {
        const loadInfo = async () => {
            document.title = `${companyState?.comercial_name} - ${t("reportpurchaseinvoices.title")}`;
            if (location.state !== null) {
                if (location.state.row && location.state.row.purchase_invoice_id) {
                    navigate("/purchaseinvoices/view", { state: { row: location.state.row } });
                }
            }
            await loadTablePreferences()
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }
        loadInfo()
    }, []);

    return (
        <>
            <Header
                size="no_title"
                child={
                    <>
                        <div className='d-flex justify-content-between'>
                            <h3>{t("reportpurchaseinvoices.title")}</h3>
                            <FilterTable
                                setIsLoadingDataTable={setIsLoadingDataTable}
                                setDataTable={setPurchasesInvoiceData}
                                showSnackBar={showSnackBar}
                                columnsTable={columnsPurchaseinvoices}
                                initFilter={initFilter}
                                resourceRoute="/reportpurchaseinvoices"
                            />
                        </div>
                    </>
                }
            />
            {!unauthorized && <div className='screen-container d-flex flex-column justify-content-center align-items-center'> <img alt='ERROR' style={{ height: "20rem", width: "20rem" }} src={require("../../../../assets/img/error.webp")} /> <h2>{messageSnack}</h2> </div>}

            {(isLoadedMyLocalPreferences) ?
                <Box sx={{ height: 'calc(100vh - 180px)', width: '100%' }}>
                    <DataTableSticky
                        columns={columns}
                        setColumns={setColumns}
                        data={purchasesInvoiceData ?? []}
                        entityId={"purchase_invoice_id"}
                        entity={`PurchaseInvoices`}
                        preferences={myPreferences}
                        namePreferences={"/reportpurchaseinvoices"}
                        nameOrderColumns={"/reportpurchaseinvoices"}
                        countColumns={["subtotal_amount", "total_amount", "tax_amount", "discount_amount", "retention_amount", "total_company_currency_amount"]}
                        isLoading={isLoadingDataTable}
                        isChildren={true}
                        sortPreference={mySortPreference}
                        selectRows={true}
                    />
                </Box>
                :
                <Spinner isBox={false} />
            }
            <SnackbarComponent />
        </>
    )
}
